module.exports = __webpack_public_path__ + "static/img/kids_3.73ee7955.png";